export default {
  install(app, params) {

    // Import all the functions under the $functions namespace inside Vue
    const files = require.context('./', true, /\.vue$/i);
    files.keys().map(key => {
      app.component(key.split('/').pop().split('.')[0], files(key).default)
    });
  }
};